import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {ApiService} from '../../@core/service/api.service';
import {SidebarCommon} from '../../@core/common/sidebar';
import {
  BusinessModel,
  EProjectDevelopmentDisplay,
  EProjectQuantityUnit,
  EProjectQuantityUnitDisplay,
  ProjectListModel,
  ProjectModel, UserModel,
} from '../../@models';
import {applyFilter} from '../../@core/common/filter';
import { AuthGuardService } from '../../@core/service/auth-guard.service';

@Component({
    selector: 'ngx-my-projects',
    templateUrl: './my-projects.component.html',
    styleUrls: ['./my-projects.component.scss']
})
export class MyProjectsComponent extends SidebarCommon<ProjectModel> implements OnInit, OnDestroy {

  projects: ProjectListModel[];

  selected: ProjectModel;

  subscription: Subscription;

  public search: string;

  me: UserModel;

  showAll: boolean = false;

  p: number = 1;

  business: BusinessModel[];
  businessSubscription: Subscription;

  customer: BusinessModel;

  ProjectQuantityUnit = EProjectQuantityUnit;
  unitOptions = EProjectQuantityUnitDisplay;
  developmentOptions = EProjectDevelopmentDisplay;

  constructor(private api: ApiService, private auth: AuthGuardService) {
    super();
  }

  async ngOnInit(): Promise<void> {
    this.auth.loadMe().then(x => this.me = x);

    this.subscription = this.api.myProjectList().subscribe(pl => {
      this.projects = pl
    });
    this.businessSubscription = this.api.reloadBusiness().subscribe(b => this.business = b);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.businessSubscription.unsubscribe();
  }

  toggleSidebar(item: ProjectModel) {
    if (item != null && item._id != null) {
      this.loadCustomer(item._id);
    }
    super.toggleSidebar(item);
  }

  async load(item) {
    this.selected = await this.api.getProjectFromServer(item._id);
    if (this.selected.unit == null) this.selected.unit = EProjectQuantityUnit.Disabled;
    if (this.selected.quantity == null) this.selected.quantity = 0;
    if (this.selected.price == null) this.selected.price = 0;
    this.toggleSidebar(this.selected);
  }

  toggleActive(item: ProjectListModel) {
    const project = this.api.getProject(item._id);
    item.active = project.active = !item.active;
    project.showInReport = item.active;
    this.api.saveProject(project);
  }

  create() {
    super.create();
    this.customer = null;
    this.selected.showInReport = true;
  }

  loadCustomer(_id) {
    this.customer = this.business?.find(x => x.projects.find(y => y._id === _id) != null );
  }

  save(item: ProjectModel) {
  }

  cancel(item: ProjectModel) {
  }

  onProjectSaved(project: ProjectModel) {
    this.hideSidebar();
    const reload$ = this.showAll ? this.api.projectList() : this.api.myProjectList();
    reload$.subscribe(pl => this.projects = pl);
  }

  onProjectCancelled() {
    this.hideSidebar();
  }

  isDeactivated(item: ProjectModel) {
    return  ['Cancelled', 'OnHold', 'Finished'].includes(item.status as undefined as string);
  }

  filter(search: string, projects: ProjectListModel[]): ProjectListModel[] {
    return applyFilter<ProjectListModel>(search, projects,
      ['name', 'material', 'customer', 'information', 'businessUnit', 'type', 'status', 'connectedDocuments']
    )?.sort((a,b) => a.active ? -1 : 1);
  }

  changeShowAll(value: boolean) {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }
    if (value) {
      this.subscription = this.api.projectList().subscribe(pl => {
        this.projects = pl
      });
    } else {
      this.subscription = this.api.myProjectList().subscribe(pl => {
        this.projects = pl
      });
    }
  }
}